import { BrandIcon } from '@spinwise/react-component-library/BrandIcon';
import { IApplicationState } from '@spinwise/spinwise-core';
import GameThumbnailManager from 'Components/shared/GameThumbnailManager/GameThumbnailManager';
import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { WHEEL_PRIZE_DATA } from '../types';
import { EWheelBonusOverlays, EWheelBonusOverlayStorage } from '../WheelBonusIframe';
import styles from './WheelWinLayout.module.scss';
import { t } from 'i18next';

export const WinLayout = ({ winSection }) => {
  const activeBonusEid = useSelector((store: IApplicationState) => store.accountReducer.info?.activeBonus?.eid);
  const integrationKeys = useSelector((state: IApplicationState) => state.globalReducer?.integrationKeys);

  const router = useRouter();
  // set tag 'activate later' as default
  const iconPath = WHEEL_PRIZE_DATA[winSection?.imageBE]?.icon;
  const shadow = WHEEL_PRIZE_DATA[winSection?.imageBE]?.color;
  const bonusAmount = winSection.count;
  const bonusType = WHEEL_PRIZE_DATA[winSection?.imageBE]?.name;
  return (
    <div className={styles.win_layout} key={winSection?.imageBE}>
      <div className={styles.win_content}>
        <div className={styles.win_icon_container}>
          <img className={styles.confetti} src="/images/wheel-bonus/win_confetti.svg" alt="" />
          <div className={styles.win_icon} style={{ filter: `drop-shadow(0px 0px 16px ${shadow})` }}>
            <BrandIcon iconPath={iconPath} iconSize={128} />
          </div>
        </div>

        <div className={styles.win_title}>
          <p>
            <b>{t('wheel.page.win.screen.title')}</b>
            <br /> {bonusAmount} {t(bonusType)}
          </p>
        </div>
        {winSection?.free_rounds ? (
          <div className={styles.win_game}>
            <p>{t('wheel.page.win.screen.on.game')}</p>
            <div className={styles.game_container}>
              <GameThumbnailManager
                game={winSection?.free_rounds.game}
                integrationKeys={integrationKeys.keys?.[winSection?.free_rounds?.game?.urlKey]}
                isSquare={true}
                size={72}
                isTextContainer={false}
              />
            </div>
            <p>{winSection.game}</p>
          </div>
        ) : null}
        {winSection?.coefficient ? (
          <p className={styles.win_wager}>
            {t('wheel.page.win.screen.wager', {
              WAGER: winSection?.coefficient,
            })}
          </p>
        ) : null}
        <div className={styles.win_buttons}>
          <button
            onClick={() => {
              // check if user has activated bonus
              if (activeBonusEid) {
                localStorage.setItem(
                  EWheelBonusOverlayStorage.POPUP_NAME,
                  EWheelBonusOverlays.WARNING_HAS_ACTIVE_BONUS,
                );
                router.replace(PATHS.LOBBY);
              } else {
                localStorage.setItem(EWheelBonusOverlayStorage.POPUP_NAME, EWheelBonusOverlays.ACTIVATE_BONUS);
                router.replace(PATHS.LOBBY);
              }
            }}
            className={styles.win_button_activate}
          >
            {t('wheel.page.win.screen.button.activate')}
          </button>
          {/* {t('wheel.page.win.btn.later')} */}
          <button
            onClick={() => {
              localStorage.setItem(EWheelBonusOverlayStorage.POPUP_NAME, EWheelBonusOverlays.WARNING_ACTIVATE_LATER);
              router.replace(PATHS.LOBBY);
            }}
            className={styles.win_button_later}
          >
            {t('wheel.page.win.screen.button.later')}
          </button>
        </div>
      </div>
    </div>
  );
};
